<template>
  <div id="transferManage">
    <div class="search">
      <div class="searchInline">
        <div style="margin-right: 10px;">位置</div>
        <!-- <el-input v-model="storeInfo.areaInfo" placeholder="新芒果大厦" clearable style="width: 280px;"></el-input> -->
        <el-row class="demo-autocomplete">
        <el-col :span="12">
          <el-autocomplete
            class="inline-input"
            v-model="state2"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            :trigger-on-focus="false"
            @select="handleSelect"
          ></el-autocomplete>
        </el-col>
        </el-row>
      </div>
      <div class="searchInline">
      <el-select @change="submitSearchch" v-model="searchParams.gcParentId" placeholder="请选择分类">
        <el-option  :label="item.scName" :value="item.scId" v-for="(item, index) in Business" :key='index'></el-option>
      </el-select>
    </div>
      <div class="searchInline">
        <el-select
          v-model="searchParams.area"
          @change="submitSearch"
          placeholder="请选择商家地区"
          clearable
        >
          <el-option label="北京市" :value="0"></el-option>
          <el-option label="郑州市" :value="1"></el-option>
          <el-option label="开封市" :value="2"></el-option>
          <el-option label="洛阳市" :value="3"></el-option>
          <el-option label="平顶山市" :value="4"></el-option>
          <el-option label="安阳市" :value="5"></el-option>
          <el-option label="鹤壁市" :value="6"></el-option>
          <el-option label="新乡市" :value="7"></el-option>
          <el-option label="焦作市" :value="8"></el-option>
          <el-option label="濮阳市" :value="9"></el-option>
          <el-option label="许昌市" :value="10"></el-option>
          <el-option label="漯河市" :value="11"></el-option>
          <el-option label="三门峡市" :value="12"></el-option>
          <el-option label="南阳市" :value="13"></el-option>
          <el-option label="商丘市" :value="14"></el-option>
          <el-option label="信阳市" :value="15"></el-option>
          <el-option label="周口市" :value="16"></el-option>
          <el-option label="驻马店市" :value="17"></el-option>
          <el-option label="济源市" :value="18"></el-option>
        </el-select>
      </div>
      <div class="searchInline">
        <el-input v-model="searchParams.Name" placeholder="商家名称" clearable></el-input>
      </div>
      <div class="searchInline">
        <el-button type="primary" @click="Inquire()">查询</el-button>
      </div>
      <div class="searchInline">
        <el-button type="primary" @click="searchClear(1)">清除</el-button>
      </div>
    </div>
    <div class="contentView">
      <el-table :data="content" style="width: 100%;">
        <el-table-column prop="storeName" label="商家名称" min-width="100"></el-table-column>
        <el-table-column prop="storeCatagory" label="商家类型" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.storeCatagory === 0">普通商家</span>
            <span v-if="scope.row.storeCatagory === 1">连锁商家</span>
          </template>
        </el-table-column>
        <el-table-column prop="scName" label="商家分类" min-width="100"></el-table-column>
        <el-table-column prop="sgName" label="商家等级" min-width="100"></el-table-column>
        <el-table-column prop="mobareaInfoile" label="商家位置" min-width="280">
          <template slot-scope="scope">
            <span class="diq">{{scope.row.distance}}km | {{scope.row.areaInfo}}</span>
            <span @click="display(scope.row)">
              <span @click="mapPositioning = true">
                <i class="el-icon-location"></i>查看地图
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderCount" label="订单量" min-width="120"></el-table-column>
        <el-table-column prop="commentSocre" label="累计评分" min-width="120"></el-table-column>
        <el-table-column prop="mobile" label="操作" min-width="130">
          <template slot-scope="scope">
            <span @click="RelatedProducts(scope)">
              <span class="to_able" style="color: #02A7F0;" @click="Selectrelatedproducts = true">查看商品</span>
            </span>
            <span class="to_able" style="color: #02A7F0;" @click="copyUrl(scope.row)">复制URL</span>
          </template>
        </el-table-column>
      </el-table>
      <input type="text" id="inputValue" style="opacity: 0" value v-model="conment" name />
      <div class="pagination">
        <el-pagination
          @size-change="sizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10,20,30,40]"
          :page-size="searchParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalResult"
        ></el-pagination>
      </div>
    </div>
    <!-- <el-dialog title="" :visible="mapPositioning"> -->
    <div class="dtPositioningg" v-show="mapPositioning">
      <div class="dtPositioning">
        <div class="cha" @click="cancel">×</div>
        <div style="float: left;width:100%;margin-bottom: 10px;font-size: 13px;">{{currentmc}}</div>
        <div style="float: left;width:100%;margin-bottom: 10px;font-size: 13px;">地址：{{currentdz}}</div>
        <el-col :span="12" style="width: 720px;height: 600px;float: left;">
          <div id="allmap"></div>
        </el-col>
      </div>
    </div>
    <!-- </el-dialog> -->

    <!-- 选择商品 -->
    <el-dialog title="全部商品" :visible.sync="Selectrelatedproducts">
      <div>
        <div>
          <el-table :data="commodityList" key="tableData" style="width: 100%">
            <el-table-column prop="mobile" label min-width="30">
              <template slot-scope="scope">
                <img :src="scope.row.goodsImage" style="width: 30px;height: 30px;" alt />
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label min-width="200">
              <template slot-scope="scope">
                <span>{{scope.row.goodsName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label>
              <template slot-scope="scope">
                <span>原价{{scope.row.buyPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label>
              <template slot-scope="scope">
                <span>会员价{{scope.row.vipPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label>
              <template slot-scope="scope">
                <span class="to_able" style="color: #02A7F0;" @click="copyUrlsp(scope.row)">复制URL</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script src="https://cdn.staticfile.org/vue-resource/1.5.1/vue-resource.min.js"></script>
<script>
import { devCode } from '@/http/baseUrl';
import loadMap from '@/http/Bmap.js';
export default {
  name: 'transferManage',
  data () {
    return {
      searchParams: {
        mobile: '',
        Name: '',
        isAccount: '',
        area: '',
        scId: '',
        gcParentId: '',
        classId: '',
        time: [],
        ffTime: [],
        pageSize: 10,
        pageIndex: 0
      },
      tableData: [
        {
          mobile: 33
        }
      ],
      ids: '',
      bmapKey: 'uoIygmc3eClZXGtfvujiCo7mpI1DAxhf',
      Selectrelatedproducts: false,
      mapPositioning: false,
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      dialog: {
        submit: {
          show: true,
          userName: '',
          manageId: '',
          batchNo: ''
        }
      },
      storeInfo: {
        areaInfo: '',
        distance: '',
        lat: '34.779931',
        lng: '113.725078',
        storeId: 31,
        storeImage: '',
        storeName: '友途官方店铺',
        storeTel: '400366365',
        workTime: ''
      },
      content: [],
      cityData: [],
      coordinate: '',
      currentmc: '',
      currentdz: '',
      Business: [],
      commodityList: [],
      value: '',
      conment: '',
      father: '',
      BusinessSub: [],
      mapresult: [],
      restaurants: [],
      state2: '新芒果大厦'
    };
  },
  created () {
    this.Businesssort();
    // this.getList();
    this.Inquire();
    this.get()
  },
  methods: {
    // 查询
    Inquire () {
      this.display();
      console.log(this.storeInfo, '88888');
      setTimeout(() => {
        this.getList();
      }, 1000);
    },
    display (nun) {
      if (nun) {
        this.currentmc = nun.storeName;
        this.currentdz = nun.areaInfo;
        this.$nextTick(() => {
          setTimeout(() => {
            this.setMap({
              lat: nun.lat,
              lng: nun.lng,
              storeName: nun.storeName,
              address: this.storeInfo.areaInfo
            });
          }, 0);
        });
      } else {
        this.$nextTick(() => {
          setTimeout(() => {
            this.setMap({
              lat: this.storeInfo.lat,
              lng: this.storeInfo.lng,
              storeName: this.storeInfo.storeName,
              address: this.storeInfo.areaInfo
            });
          }, 0);
        });
      }
    },
    // 百度地图API功能
    setMap (storeInfo) {
      loadMap(this.bmapKey)
        .then(() => {
          // 百度地图API功能
          var map = new BMap.Map('allmap');
          var point = new BMap.Point(storeInfo.lng, storeInfo.lat);
          console.log('----验证地图是否加载----', map);
          var marker = new BMap.Marker(point); // 创建标注
          map.addOverlay(marker); // 将标注添加到地图中
          map.centerAndZoom(point, 15);
          // 创建地址解析器实例
          var myGeo = new BMap.Geocoder();
          // 将地址解析结果显示在地图上,并调整地图视野
          myGeo.getPoint(this.storeInfo.areaInfo, point => {
            this.storeInfo.lat = point.lat;
            this.storeInfo.lng = point.lng;
          });
          //  var opts = {
          //    width : 200,     // 信息窗口宽度
          //    height: 100,     // 信息窗口高度
          //    title : storeInfo.storeName , // 信息窗口标题
          //    enableMessage:true,//设置允许信息窗发送短息
          //    message: storeInfo.address
          //  }
          //  var infoWindow = new BMap.InfoWindow(storeInfo.address, opts);  // 创建信息窗口对象
          //  marker.addEventListener("click", function(){
          //    map.openInfoWindow(infoWindow,point); //开启信息窗口
          //  });
        });
      // .catch(err => {
      //   console.log('地图加载失败');
      // });
    },
    // 复制URL
    copyUrl (item) {
      let ceshiurl;
      if (window.location.hostname === 'crm.yotur.cn') {
        ceshiurl =
          'https://www.youtoo365.com' +
          '/webApp/nearby/storeDetail?storeId=' +
          item.storeId +
          '&lat=' +
          item.lat +
          '&lng=' +
          item.lng;
      } else {
        ceshiurl =
          'http://218.29.121.74:8081' +
          '/webApp/nearby/storeDetail?storeId=' +
          item.storeId +
          '&lat=' +
          item.lat +
          '&lng=' +
          item.lng;
      }
      let doc = document.getElementById('inputValue');
      doc.value = ceshiurl;
      doc.select();
      document.execCommand('Copy');
      this.$message.success('复制成功');
    },
    copyUrlsp (item) {
      let ceshiurl;
      if (window.location.hostname === 'crm.yotur.cn') {
        ceshiurl =
          'https://www.youtoo365.com' +
          '/webApp/nearby/product?goodsCommonId=' +
          item.goodsCommonId +
          '&goodsId=' +
          item.goodsId +
          '&storeId=' +
          item.storeId;
      } else {
        ceshiurl =
          'http://218.29.121.74:8081' +
          '/webApp/nearby/product?goodsCommonId=' +
          item.goodsCommonId +
          '&goodsId=' +
          item.goodsId +
          '&storeId=' +
          item.storeId;
      }
      let doc = document.getElementById('inputValue');
      doc.value = ceshiurl;
      doc.select();
      document.execCommand('Copy');
      this.$message.success('复制成功');
    },
    // 获取列表数据
    getList () {
      if (this.searchParams.area === 0) {
        this.searchParams.isAccountt = '北京市';
      } else if (this.searchParams.area === 1) {
        this.searchParams.isAccountt = '郑州市';
      } else if (this.searchParams.area === 2) {
        this.searchParams.isAccountt = '开封市';
      } else if (this.searchParams.area === 3) {
        this.searchParams.isAccountt = '洛阳市';
      } else if (this.searchParams.area === 4) {
        this.searchParams.isAccountt = '平顶山市';
      } else if (this.searchParams.area === 5) {
        this.searchParams.isAccountt = '安阳市';
      } else if (this.searchParams.area === 6) {
        this.searchParams.isAccountt = '鹤壁市';
      } else if (this.searchParams.area === 7) {
        this.searchParams.isAccountt = '新乡市';
      } else if (this.searchParams.area === 8) {
        this.searchParams.isAccountt = '焦作市';
      } else if (this.searchParams.area === 9) {
        this.searchParams.isAccountt = '濮阳市';
      } else if (this.searchParams.area === 10) {
        this.searchParams.isAccountt = '许昌市';
      } else if (this.searchParams.area === 11) {
        this.searchParams.isAccountt = '漯河市';
      } else if (this.searchParams.area === 12) {
        this.searchParams.isAccountt = '三门峡市';
      } else if (this.searchParams.area === 13) {
        this.searchParams.isAccountt = '南阳市';
      } else if (this.searchParams.area === 14) {
        this.searchParams.isAccountt = '商丘市';
      } else if (this.searchParams.area === 15) {
        this.searchParams.isAccountt = '信阳市';
      } else if (this.searchParams.area === 16) {
        this.searchParams.isAccountt = '周口市';
      } else if (this.searchParams.area === 17) {
        this.searchParams.isAccountt = '驻马店市';
      } else if (this.searchParams.area === 18) {
        this.searchParams.isAccountt = '济源市';
      }
      this.axios
        .get('/member/recommondStoreList' + devCode, {
          params: {
            lat: this.storeInfo.lat,
            lng: this.storeInfo.lng,
            keyWord: this.searchParams.Name || '',
            area: this.searchParams.isAccountt || '',
            scId: this.searchParams.scId || '',
            pageIndex: this.searchParams.pageIndex || '',
            pageSize: this.searchParams.pageSize || ''
          }
        })
        .then(res => {
          this.content = res.data.resultData.content;
          this.totalResult = res.data.resultData.total;
        });
    },
    // 获取商家分类
    Businesssort () {
      this.axios
        .get('member/storeClass' + devCode, {
          params: {
            scParentId: ''
          }
        })
        .then(res => {
          this.Business = res.data.data;
          console.log(this.Business);
        });
    },
    // 查看关联商品
    RelatedProducts (scope) {
      let storeId = scope.row.storeId;
      this.axios
        .get('member/recommondStoreGoodsList' + devCode, {
          params: {
            storeId: storeId
          }
        })
        .then(res => {
          this.commodityList = res.data.resultData;
        });
    },
    // 搜索列表
    submitSearch () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 搜索列表
    submitSearch1 () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 清除
    searchClear (num) {
      if (num === 1) {
        this.clearListSearch();
      } else if (num === 2) {
        this.clearListSearch2();
        this.getUserList();
      }
    },
    // 清除列表的搜索表单
    clearListSearch () {
      this.searchParams = {
        mobile: '',
        Name: '',
        isAccount: '',
        isAccountt: '',
        time: [],
        ffTime: [],
        pageSize: 10,
        pageIndex: 0
      };
      this.state2 = '新芒果大厦';
      this.storeInfo.lat = '34.779931';
      this.storeInfo.lng = '113.725078';
      this.getList();
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.getList();
    },
    // 打开提交审核
    openSubmit (obj) {
      console.log(obj);
      this.ids = obj.id;
      this.dialog.submit.show = true;
    },
    submitConfirm () {
      this.axios({
        url: `/agentAwardBatch/transfer` + devCode,
        method: 'post',
        data: {
          ids: this.ids
        }
      }).then(res => {
        if (res.data.ok) {
          this.$message.success(res.data.data);
          this.dialog.submit.show = false;
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    cancel () {
      this.mapPositioning = false;
    },
    handleChange (value) {
      console.log(value);
    },
    //  选择商品分类显示二级
    submitGoodsType () {
      let goodsTypeId = this.searchParams.gcParentId;
      let Business = this.Business;
      let goodsTypeListSelected = Business.filter(item => {
        return goodsTypeId === item.scId;
      });
      this.axios
        .get('member/storeClass' + devCode, {
          params: {
            scParentId: goodsTypeListSelected[0].scParentId
          }
        })
        .then(res => {
          this.BusinessSub = res.data.data;
          console.log(this.BusinessSub);
        });
      // this.goodsTypeListSub = goodsTypeListSelected[0].childList || [];
      // this.searchParams.classId = '';
    },
    submitSearchch (value) {
      this.searchParams.scId = value;
      this.getList();
    },
    showLocation (res) {
      console.log(res);
    },
    get () {
      // console.log('1111111111111++++++')
      //发送get请求
    },
    querySearch (queryString, cb) {
      console.log(cb)
      this.$jsonp('https://api.map.baidu.com/place/v2/suggestion?callback=showLocation&output=json&pois=1' , {
        ak: 'EdBniDOEHqUd2puGyxReOK8C4f2SlVRL',
        query: queryString,
        region: '河南'
      }).then((res)=>{
        if (res.message) {
          let d = res.result;
          let aa = d.map(item => {
            return {
              address: item.province + item.city + item.district + item.name,
              value: item.name,
              lag: item.location.lat,
              lng: item.location.lng
            }
          });
          console.log('3333333333')
          cb(aa);
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    handleSelect(item) {
      console.log(item);
      this.storeInfo.lat = item.lag
      this.storeInfo.lng = item.lng
      this.getList()
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss">
.el-table th div.renderHeader {
  line-height: 14px;
  padding: 0;
  margin-top: 4px;
  span {
    margin-right: 5px;
  }
  i {
    cursor: pointer;
  }
}
.searchInline {
  float: left;
}
.searchInline div {
  float: left;
  line-height: 32px;
  font-size: 13px;
  color: #333;
}
.el-dialog__header {
  text-align: center;
}
.diq {
  width: 310px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#allmap {
  width: 680px !important;
  height: 555px !important;
  float: left !important;
}
.dtPositioning {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -360px;
  margin-top: -333.5px;
  height: 670px;
  width: 720px;
  background: #fff;
  padding: 0 15px;
}
.dtPositioningg {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.49);
}
.cha {
  float: right;
  font-size: 28px;
  margin-top: 10px;
}
.el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/serveRecd/storeRecd.vue